import LineChart from "./LineChart"
import PieChart from "./PieChart"
import BarChartWrapper from "./BarChart"
import ResponsiveContainer from "./ResponsiveContainer"
export default {
    LineChart,
    PieChart,
    BarChart: BarChartWrapper,
    ResponsiveContainer,
};